import { FieldTypes, WellYieldDrawdownFieldsEdit } from '../../../../types/form-types'
import { useEffect } from 'react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { ValidationErrors } from '../../../hooks/use-edit-form'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { FormField, FormFieldRow, TextInput } from '@msaf/core-react'

interface DrawdownTestStepEditCardProps {
  isLoading: boolean
  drawdownTestFields: Partial<WellYieldDrawdownFieldsEdit>
  stepNo: number
  id: number
  setValue: (key: keyof WellYieldDrawdownFieldsEdit, value: FieldTypes) => void
  validationErrors?: ValidationErrors
}
export default function DrawdownTestStepEditCard({
  isLoading,
  stepNo,
  id,
  drawdownTestFields,
  setValue,
  validationErrors = {},
}: DrawdownTestStepEditCardProps) {
  useEffect(() => {
    document.getElementById(`yieldDrawdownTestStep${id}`)?.focus()
  }, [id])
  return (
    <>
      <FormFieldRow>
        <FormField
          isSkeleton={isLoading}
          htmlFor={`yieldDrawdownTestStep${id}`}
          label='Step'
          validationMessages={validationErrors?.stepNo}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`yieldDrawdownTestStep${id}`}
            value={`${stepNo}`}
            setValue={(value: FieldTypes) => setValue('stepNo', Number(value))}
            isInvalid={!!validationErrors?.stepNo}
          />
        </FormField>

        <FormField
          isSkeleton={isLoading}
          htmlFor={`yieldDrawdownTestStep${id}`}
          label='Minutes'
          validationMessages={validationErrors?.stepDuration}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`yieldDrawdownTestStepDuration${id}`}
            value={`${drawdownTestFields.stepDuration ?? ''}`}
            setValue={(value: FieldTypes) => setValue('stepDuration', Number(value))}
            isInvalid={!!validationErrors?.stepDuration}
          />
        </FormField>
      </FormFieldRow>

      <FormFieldRow>
        <FormField
          isSkeleton={isLoading}
          htmlFor={`yieldDrawdownTestYield${id}`}
          label='Yield'
          toolTipMessage={TOOLTIP.yield}
          validationMessages={validationErrors?.yieldValue}
          isRequired
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`yieldDrawdownTestYield${id}`}
            value={`${drawdownTestFields.yieldValue ?? ''}`}
            setValue={(value: FieldTypes) => setValue('yieldValue', Number(value))}
            isInvalid={!!validationErrors?.yieldValue}
          />
        </FormField>

        <FormField
          toolTipMessage={TOOLTIP.drawdown}
          isSkeleton={isLoading}
          htmlFor={`yieldDrawdownDrawdown${id}`}
          label='Drawdown(m)'
          validationMessages={validationErrors?.drawdown}
          isRequired
        >
          <TextInput
            isSkeleton={isLoading}
            id={`yieldDrawdownTestDrawdown${id}`}
            value={`${drawdownTestFields.drawdown ?? ''}`}
            setValue={(value: FieldTypes) => setValue('drawdown', Number(value))}
            isInvalid={!!validationErrors?.drawdown}
          />
        </FormField>
      </FormFieldRow>
    </>
  )
}
